import { inject, observer } from "mobx-react";

import Default from "./Default";

import { useAbTestComponent } from "@utils";

const abTests = {
    "dev_1172_07.11.2025": () => import("./AB_1172"), // 15/01/26 не тестировали еще
};

const Timer = inject("mainStore")(
    observer(({ mainStore, ...props }) => {
        const init = mainStore.getMainStore("init");
        const Specified = useAbTestComponent({ init, abTests, defaultComponent: Default, matchValue: "v2" });

        return <Specified {...props} />;
    }),
);

export default Timer;
